import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { ImportTariffModel } from '../../../core/models/tariff.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { emailValidator } from '../../../shared/utils/email_validator'

@Component({
  selector: 'modal-purchases-email',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './modal-purchases-email.component.html',
  styleUrl: './modal-purchases-email.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalPurchasesEmailComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalPurchasesEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.propostaId) {
      this.propostaId = data.propostaId
    }
  }

  propostaId: number = -1
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  file: File | null = null

  ngOnInit(): void {
    this.createForm()
  }

  createModel() {
    return {
      propostaId: this.propostaId,
      email: this.form.get('email')?.value ?? '',
    }
  }

  close() {
    this.dialogRef.close()
  }

  sendEmail() {
    this.loading = true
    const model = this.createModel()
    this.proposalClientService.sendProposalClientPurchase(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, emailValidator()]],
    })
  }
}
